<template>
  <div class="personal" style="width: 370px">
    <t-form :data="form" :rules="rules" ref="form"  @submit="OrgaddUser" labelWidth="130px" labelAlign="right">
        <t-form-item label="原密码" name="password">
            <t-input type="password" v-model="form.password"></t-input>
        </t-form-item>
        <t-form-item label="修改后密码" name="update_password">
            <t-input type="password" v-model="form.update_password"></t-input>
        </t-form-item>
        <t-form-item  style="margin-left: 320px">
            <t-button theme="primary" type="submit" >确认</t-button>
        </t-form-item>
    </t-form>
  </div>
</template>

<script>
export default {
    name:"personal",
    data(){
        return{
            // 表单字段
            form:{
                password:"",//原密码
                update_password:"",//修改后密码
            },
            // 表单验证
            rules:{
              password: [{required: true,message: '请输入原密码',type: 'error'}],
              update_password: [{required: true,message: '请输入修改之后的密码',type: 'error'}],
           },
        }
    },
    created(){

    },
    methods: {
        // 表单提交
        // 修改账号信息
        OrgaddUser(){
            this.$http({
                url:"api/user_core/",
                method:"POST",
                data:{
                    organ_name:localStorage.getItem("organ_name"),
                    password:this.form.password,
                    update_password:this.form.update_password
                }
            }).then(res=>{
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                    this.dialogVisible = false
                    this.form.update_password=""
                    this.form.password=""
                }else{
                    this.$message.error(res.data.message);
                    this.dialogVisible = false
                    this.form.update_password=""
                    this.form.password=""
                }
            })
        },
    },
    
}
</script>

<style lang='scss' scoped>

</style>